import { useState, useEffect } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de painéis de LED.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      className={`whatsapp-btn ${isVisible ? 'whatsapp-btn--visible' : ''}`}
      onClick={handleWhatsAppClick}
      aria-label="Fale conosco no WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
      <span className="whatsapp-btn__pulse"></span>
    </button>
  );
};

export default WhatsAppButton;
